import { mapActions, mapGetters } from 'vuex';
import contentHeader from '@/components/generics/content-header/content-header.vue';
import catchHtmlClickMixin from '@/helpers/catchHtmlClickMixin';
import faq from '@/components/support/faq/faq.vue';
import { MODALS } from '@/components/app/app-modals/modals-constants';
import supportMixin from '@/mixins/support';
import cmsContentMixin from '@/mixins/cmsContent';
import { STATIC_PAGES } from '@/constants';
import staticPageHeader from '@/components/static-page-header/static-page-header.vue';
import { BRAND } from '@/components/brand-name/brand-name.js';
import loaderMixin from '@/mixins/loader';
import contentLoaderMixin from '@/mixins/contentLoader';

const DEFAULT_TITLE = `What is ${BRAND}?`;

export default {
  mixins: [
    cmsContentMixin,
    catchHtmlClickMixin,
    supportMixin,
    loaderMixin,
    contentLoaderMixin,
  ],
  props: {
    title: {
      type: String,
      default: DEFAULT_TITLE,
    },
  },
  components: {
    contentHeader,
    faq,
    staticPageHeader
  },
  metaInfo() {
    return {
      title: 'Support',
    };
  },
  data() {
    return {
      topBasics: [
        {
          name: DEFAULT_TITLE,
          text: '',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
    topics() {
      return this.isLayoutMobile ? [] : [this.topBasics[0]];
    },
  },
  methods: {
    ...mapActions('browse', ['getStaticPageFull']),
    ...mapActions('popup', ['setCurrentPopup']),
    openResearch() {
      this.setCurrentPopup(MODALS.RESEARCH);
    },
  },
  created() {
    this.loaderAdd(document.body);
    this.getStaticPageFull(STATIC_PAGES.WHAT_IS)
      .then((data) => {
        this.isComponentReady = true;
        this.installDynamicControls({ data });
      }).then(() => this.loaderRemove(document.body))
      .catch(() => this.loaderRemove(document.body));
  },
};



// WEBPACK FOOTER //
// ./src/components/support/what-is-predictit/what-is-predictit.js